import React from "react";
import { Box, Typography } from "@mui/material";
import { FileFormField } from "../common/components/FormFields";
import { LetterOfSupportInfo } from "./LetterOfSupportInfo";
import FileCopyIcon from "@mui/icons-material/FileCopy";

export interface LettersOfSupportProps {}

export function LettersOfSupport({}: LettersOfSupportProps) {
  return (
    <Box>
      <Typography variant="h5">Letters of Support</Typography>
      <Box m={2}>
        <LetterOfSupportInfo />
      </Box>
      <FileFormField
        name="lettersOfSupport"
        description="Letter of support and any supporting documents"
        multiFile
        noIcon
      />
      <Typography variant="body1" m={2}>
        Upload all your letters and supporting documents here. You can add
        multiple files at once.
      </Typography>
      <Typography variant="body1" m={2}>
        <FileCopyIcon color="error" sx={{ mr: 1, verticalAlign: "middle" }} />{" "}
        Not sure what the letter needs?{" "}
        <a
          href="/documents/Inuit_Child_First_Initiative_Checklist_4.pdf"
          download="Inuit_Child_First_Initiative_Checklist.pdf"
        >
          Download the letter of support checklist (PDF)
        </a>{" "}
        to share with your professional.
      </Typography>
    </Box>
  );
}
